<template>
  <div class="modal-wrap">
    <el-dialog title="日志" :visible.sync="dialogVisible" width="1200px">
      <div class="modal-content" v-loading="loading">
        <div class="top-filter">
          <el-select class="select-item" v-model="filterData.operator" placeholder="请选择" @change="selectLogList(true)">
            <el-option label="所有操作人" :value="-1"> </el-option>
            <el-option v-for="item of operatorList" :label="item" :value="item" :key="item"> </el-option>
          </el-select>
          <el-select class="select-item" v-model="filterData.materialName" placeholder="请选择" @change="selectLogList(true)">
            <el-option label="所有素材组" :value="-1"> </el-option>
            <el-option v-for="item of materialNameList" :label="item" :value="item" :key="item"> </el-option>
          </el-select>
        </div>
        <div class="log-list">
          <log-item v-for="item of this.logList" :key="item.id" :dataItem="item"></log-item>
        </div>
        <div class="pa-wrap">
          <self-pagination
            class="footer-page"
            :total="pageData.total"
            :pageSize="pageData.size"
            :currentPage="pageData.page"
            ref="tabelPagination"
            @getCurrentPage="changePage"
            @handleSizeChange="changePageSize"
          ></self-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import LogItem from "./logItem.vue";
import { queryOperator, queryMaterialNames, queryOperateLog } from "@/api/materialManage.js";
export default {
  name: "LogModal",
  components: {
    LogItem,
  },
  data() {
    return {
      dialogVisible: false,
      filterData: {
        operator: -1,
        materialName: -1,
      },
      logList: [],
      operatorList: [],
      materialNameList: [],
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      curMaterialGroupInfoId: null,
      loading: false,
    };
  },
  methods: {
    selectList() {
      queryOperator({
        materialGroupId: this.curMaterialGroupInfoId,
      }).then((res) => {
        if (res.code === "0000") {
          this.operatorList = res.operators;
        }
      });
      queryMaterialNames({
        materialGroupId: this.curMaterialGroupInfoId,
      }).then((res) => {
        if (res.code === "0000") {
          this.materialNameList = res.materialNames;
        }
      });
    },
    selectLogList(resetPage) {
      if (resetPage) {
        this.pageData.page = 1;
      }
      let parmas = {
        page: this.pageData.page + "",
        size: this.pageData.size + "",
        materialGroupId: this.curMaterialGroupInfoId,
      };
      this.filterData.operator !== -1 ? (parmas.operator = this.filterData.operator) : "";
      this.filterData.materialName !== -1 ? (parmas.materialName = this.filterData.materialName) : "";
      this.logList = [];
      this.loading = true;
      queryOperateLog(parmas).then((res) => {
        this.loading = false;
        if (res.code === "0000") {
          this.logList = res.materialOperateLogs;
          this.pageData.total = res.count;
        }
      });
    },
    showModal(data) {
      this.curMaterialGroupInfoId = data.materialGroupInfoId;
      this.filterData.operator = -1;
      this.filterData.materialName = -1;
      this.selectList();
      this.selectLogList(true);
      this.dialogVisible = true;
    },
    changePage(page) {
      this.pageData.page = page;
      this.selectLogList(false);
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.selectLogList(false);
    },
  },
};
</script>

<style lang="less" scoped>
.modal-wrap {
  /deep/ .el-dialog__body {
    padding: 14px 0 0 0;
  }
  .modal-content {
    .top-filter {
      padding: 0 32px 16px 32px;
      border-bottom: 1px solid rgba(232, 232, 232, 1);
      .select-item {
        width: 160px;
        margin-right: 24px;
      }
    }
    .log-list {
      padding: 0 16px;
      height: 600px;
      overflow: auto;
      margin: 0 16px;
      &::-webkit-scrollbar {
        width: 4px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(0, 0, 0, 0.2);
      }
    }
    .pa-wrap {
      padding-right: 16px;
    }
  }
}
</style>
